<template>
    <div class="dashboard-container">
        <side-bar />
        <div class="main-content">
            <h2>Demo Bot Setup</h2>
            <hr class="h2" />
            <div class="wizard-steps">
                <div class="current">
                    <div class="num">1</div> <span class="step">Basic Details</span>
                    <span class="arrow">&#8594;</span>
                </div>
                <div class="num">2</div> <span class="step">View FAQs</span>
                <span class="arrow">&#8594;</span>
                <div class="num">3</div> Transfers and Emails
                <span class="arrow">&#8594;</span>
                <div class="num">4</div> Finish And Test
            </div>
            <div class="container">
                <component src="https://c2hbe361.caspio.com/dp/76bfd0003f9304ff193d4e8c9894/emb" :is="'script'">
                </component>
            </div>
        </div>
    </div>
</template>
<script>
import SideBar from '../SideBar.vue'
export default {
    name: 'MainConfig',
    components: {
        SideBar
    }
}
</script>
